// @flow

export const LIGHT: 300 = 300;
export const REGULAR: 400 = 400;
export const MEDIUM: 500 = 500;
export const SEMIBOLD: 600 = 600;
export const BOLD: 700 = 700;
